import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { throttle } from 'lodash-es';

import './docked-container.scss';

export function DockedContainer({
  children,
  className = 'bg-primary-darker px-1 py-0_5',
  onDisplayChange = null,
  showElementSelector,
  scrollElementSelector = null,
  creativeId = null,
  isAfterElement = false,
}) {
  const [isDisplayed, setDisplayed] = useState(null);

  useEffect(() => {
    const onScroll = throttle(() => {
      const showElement = document.querySelector(showElementSelector);
      if (!showElement) {
        return;
      }

      const { top, bottom } = showElement.getBoundingClientRect();

      setDisplayed(isAfterElement ? bottom < 0 : top < window.innerHeight);
    }, 100);

    const scrollElement = document.querySelector(scrollElementSelector) || document;

    scrollElement.addEventListener('scroll', onScroll);

    return () => {
      scrollElement.removeEventListener('scroll', onScroll);
    };
  }, [isAfterElement, scrollElementSelector, showElementSelector]);

  useEffect(() => {
    if (isDisplayed !== null && onDisplayChange) {
      onDisplayChange(isDisplayed);
    }
  }, [isDisplayed, onDisplayChange]);

  if (isDisplayed === null) {
    return null;
  }

  return (
    <div
      className={classnames('docked-container bottom-0 left-0 w-100', className, {
        show: isDisplayed,
      })}
      data-tracking-parent={creativeId}
    >
      {children}
    </div>
  );
}

DockedContainer.propTypes = {
  children: PropTypes.node.isRequired,
  showElementSelector: PropTypes.string.isRequired,
  scrollElementSelector: PropTypes.string,
  className: PropTypes.string,
  creativeId: PropTypes.string,
  onDisplayChange: PropTypes.func,
  isAfterElement: PropTypes.bool,
};
